import gql from 'graphql-tag'
export default gql`mutation deleteReceiptMutation($receiptId: Int!) {
  deleteReceipt(receiptId: $receiptId) {
    success
  }
}`